import moment from 'moment'
import { ADMIN_ONLY_ROLES, INTERNAL_ONLY_ROLES } from './Edit/constants'
import type { CategoryType } from './types'
import type { Contact } from '__generated__/graphql'
import type { User } from 'models/user.model'
export const formatDateToLocal = (date) => {
  if (!date) return '-'
  return moment(date).format('DD/MM/YYYY')
}

export const extractTimeFromDate = (date) => {
  if (!date) return null
  return moment(date).utc().format('HH:mm')
}

export const formatDateNative = (date) => {
  if (!date) return '-'
  return new Date(date).toLocaleDateString()
}

export const shouldHideRole = (role: string, isInternal: boolean): boolean => {
  if (isInternal) return false
  return ADMIN_ONLY_ROLES.includes(role) || INTERNAL_ONLY_ROLES.includes(role)
}

export const getVisibleRoles = (category: CategoryType, isInternal: boolean): [string, boolean | undefined][] => {
  return Object.entries(category.roles).filter(([role]) => !shouldHideRole(role, isInternal))
}

export const getVisibleRoleKeys = (category: CategoryType, isInternal: boolean): string[] => {
  return Object.keys(category.roles).filter(role =>
    category.roles[role] !== undefined && !shouldHideRole(role, isInternal)
  )
}

export const isRoleDisabled = (role: string, user: User, contact: Contact | null): boolean => {
  const canEdit = user.admin || user.roles?.admin_roles
  return !canEdit || (role === 'center_beta' && contact?.roles?.center_beta)
}